/**
 * What the boards say about where gems come from. With gems on the reels
 * (reel_gems) the reels come first, in plain words: what a gem cell is
 * worth and that it pays wherever it lands.
 */

/** The gem cells on the reels, in a line. */
export const REEL_GEMS_LINE = 'Gems turn up on the reels, 5 or 10 at a time, wherever they land.';

/** The wallet board's notes: where gems come from, and that coins never run out. */
export function walletNotes(reelGems: boolean): string {
  const gems = reelGems
    ? `${REEL_GEMS_LINE} More come from wheel podiums, reel races and trail bonuses.`
    : 'Gems come from wheel podiums, reel races and trail bonuses.';
  return `${gems}\n\nCoins never run out: whenever you can't cover your bet, we top you up for free.`;
}

/** The unlock board's hint when the player is short of gems. */
export function unlockGemHint(reelGems: boolean): string {
  return reelGems
    ? 'Gems turn up on the reels as you play, and come from trail bonuses, wheel podiums and reel races.'
    : 'Earn gems from trail bonuses, wheel podiums and reel races.';
}
